import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
// import { API_URL } from "../../config/config";

const API_URL = process.env.REACT_APP_API_URL;

// Helper to get token from Redux or storage
const getAuthToken = (getState) =>
  (getState && getState().auth && getState().auth.token) ||
  sessionStorage.getItem("access_token") ||
  localStorage.getItem("access_token");

export const fetchLatestHeartRate = createAsyncThunk(
  "heartRate/fetchLatest",
  async (patientId, { rejectWithValue, getState }) => {
    try {
      const token = getAuthToken(getState);
      const response = await axios.get(
        `${API_URL}/vitals/patient/${patientId}/heart_rate/latest`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch heart rate");
    }
  }
);

const heartRateSlice = createSlice({
  name: "heartRate",
  initialState: { data: null, loading: false, error: null },
  reducers: {
    clearHeartRate(state) {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLatestHeartRate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLatestHeartRate.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchLatestHeartRate.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { clearHeartRate } = heartRateSlice.actions;

export const selectHeartRate = (state) => state.heartRate;

export default heartRateSlice.reducer;



// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
// // import { API_URL } from "../../config/config";

// const API_URL = process.env.REACT_APP_API_URL;

// export const fetchLatestHeartRate = createAsyncThunk(
//   "heartRate/fetchLatest",
//   async (patientId, thunkAPI) => {
//     try {
//       const response = await axios.get(
//         `${API_URL}/vitals/patient/${patientId}/heart_rate/latest`
//       );
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue("Failed to fetch heart rate");
//     }
//   }
// );

// const heartRateSlice = createSlice({
//   name: "heartRate",
//   initialState: { data: null, loading: false, error: null },
//   reducers: {
//     clearHeartRate(state) {
//       state.data = null;
//       state.loading = false;
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchLatestHeartRate.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchLatestHeartRate.fulfilled, (state, action) => {
//         state.data = action.payload;
//         state.loading = false;
//       })
//       .addCase(fetchLatestHeartRate.rejected, (state, action) => {
//         state.error = action.payload;
//         state.loading = false;
//       });
//   },
// });

// export const { clearHeartRate } = heartRateSlice.actions;

// export const selectHeartRate = (state) => state.heartRate;

// export default heartRateSlice.reducer;
